import React from 'react';
import { Result } from 'antd';
import useAuth from '../../hooks/useAuth';

const RequirePlatformAdmin = ({ fallback = null, children }) => {
  const { canAccessAllAccounts } = useAuth();

  if (!canAccessAllAccounts) {
    if (fallback) {
      return fallback;
    }
    return (
      <Result
        status="403"
        title="Sin acceso"
        subTitle="Esta sección está reservada para administradores de la plataforma."
      />
    );
  }

  return children;
};

export default RequirePlatformAdmin;
